import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Title for edit supplier modal in product details',
    defaultMessage: 'Edit Supplier',
    id: 'aqYDiS',
  },
  supplierSkuLabel: {
    description: 'Label for supplier SKU input in edit supplier modal',
    defaultMessage: 'Supplier SKU',
    id: '+SGgtp',
  },
  supplierSkuPlaceholder: {
    description: 'Placeholder for supplier SKU input in edit supplier modal',
    defaultMessage: 'Enter supplier SKU',
    id: 'KAjvLg',
  },
  unitCostLabel: {
    description: 'Label for unit cost input in edit supplier modal',
    defaultMessage: 'Unit Cost',
    id: 'DYWazB',
  },
  cancel: {
    description: 'Cancel button text in edit supplier modal',
    defaultMessage: 'Cancel',
    id: 'ZO4mZK',
  },
  save: {
    description: 'Save button text in edit supplier modal',
    defaultMessage: 'Save',
    id: '1Dm+HD',
  },
  errorNotificationTitle: {
    description: 'Error notification title in edit supplier modal',
    defaultMessage: 'Error',
    id: '8GuwwY',
  },
  errorNotificationContent: {
    description: 'Error notification content when updating product-supplier association fails',
    defaultMessage: 'Failed to update the supplier association. Please try again.',
    id: 'gPfbkC',
  },
  supplierSkuTooLongError: {
    id: 'iDGzw9',
    description: 'Error message when supplier SKU exceeds the max character length in edit supplier modal',
    defaultMessage: 'Max {maxLength} characters',
  },
});
